<template>
	<div>
		<myheader :backFlag="false" headTitle="认证企业"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div style="margin: .5rem auto .2rem;text-align: center;">
						<img style="width: 3rem; height: 3rem; "
							:src="applyStatus === '2'?success:(applyStatus==='1'?review:fail)">
						<div class="text12 textcolor666 margin_top_2">
							{{applyStatus === '2'?'认证成功':(applyStatus==='1'?'请等待审核':'认证失败')}}
						</div>
						<div v-if="applyStatus==='1'" class="text10 textcolor999 margin_top_5">
							平台将在2个工作日内进行审核，审核通过后系统会发送通知。</div>
						<div v-if="applyStatus==='2'" class="text10 textcolor666 margin_top_5">恭喜您，已通过企业实名认证，成为企业管理员
						</div>
						<div v-if="applyStatus==='2'" class="text10 textcolor999 margin_top_5">可继续进行企业印章设置！
						</div>
						<div v-if="applyStatus==='4'" class="text14 textcolor333 margin_top_3 font_weight_bold">
							{{corpName}}
						</div>
						<div v-if="applyStatus==='4'" class="text12 textcolor666 margin_top_5">
							{{'认证方式： 法人授权书认证'}}
						</div>
					</div>
				</div>
				<!-- <div class="all_tips_content_card margin_top_10">
					<div class="text14 textcolor666">企业打款状态：</div>
					<div class="text14 textcolor333 font_weight_900" style="position: absolute;right:.5rem;top: 1rem;">
						等待企业打款</div>
					<div class="horizontal_line margin_top_2"></div>
					<div class="text12 textcolor333 margin_top_5">正在等待企业打款中。</div>
				</div> -->
				<div v-if="applyStatus==='4'" class="all_tips_content_card margin_top_10">
					<div class="text14 textcolor666">资料审核状态：</div>
					<div class="text14 textcolor333 font_weight_900" style="position: absolute;right:.5rem;top: 1rem;">
						{{applyStatus==='1'?'审核中':'审核未通过'}}
					</div>
					<div class="horizontal_line margin_top_2"></div>
					<div class="text12 textcolor333 margin_top_5">
						{{applyStatus==='1'?'资料审核一般为1至2天，请耐心等待，审核通过后系统将会发送通知。':'失败原因：'+(failMessage?failMessage:'认证提交信息不完整！')}}
					</div>
				</div>
				<div v-if="applyStatus==='4'" class="text14 textcolormain all_text_center all_line_height22"
					style="margin-top: 3rem;" @click="toResetAuth()">重新认证</div>
				<div v-if="applyStatus==='1'" class="all_tips_content_card margin_top_10"
					style="margin-bottom: 3.5rem;">
					<div class="text12 textcolor999 font_weight_bold all_tips_red_after">向e签平台的对公账户打款</div>
					<div class="horizontal_line margin_top_2"></div>
					<div class="text12 textcolormain margin_top_5">请在48小时内完成打款</div>
					<div class="text12 textcolor666 margin_top_5">公司名称</div>
					<div class="all_tips_input" style="border-bottom: none;">
						<div class="my_input all_height_line16 text12 textcolor333 font_weight_bold">
							{{corporateAccountInfo.companyName}}
						</div>
					</div>
					<div class="text12 textcolor666 margin_top_5">开户行名称</div>
					<div class="all_tips_input" style="border-bottom: none;">
						<div class="my_input all_height_line16 text12 textcolor333 font_weight_bold">
							{{corporateAccountInfo.bankDeposit}}
						</div>
					</div>
					<div class="text12 textcolor666 margin_top_5">汇入银行账号</div>
					<div class="all_tips_input">
						<div class="my_input all_height_line16 text12 textcolor333 font_weight_bold">
							{{corporateAccountInfo.bankAccount}}
						</div>
					</div>
					<div class="text12 textcolor666 margin_top_5">打款金额</div>
					<div class="margin_top_2 display_flex" style="align-items: center;">
						<span class="text18 textcolormain font_weight_900">{{corporateAccountInfo.payMoney}}</span>
						<span class="text11 textcolorRed" style="margin-left: 1rem;">如未在指定时间完成打款，会造成审核不通过</span>
					</div>
					<!-- <div class="text14 textcolor666 margin_top_10">打款金额</div>
					<div class="all_tips_input">
						<div class="my_input all_height_line16 text14 textcolor333 font_weight_bold">
							{{corporateAccountInfo.payMoney}}
						</div>
					</div> -->
					<!-- <div class="text14 textcolor666 margin_top_10">打款交易码</div>
					<div class="all_tips_input">
						<div class="my_input all_height_line16 text14 textcolor333 font_weight_bold">
							{{corporateAccountInfo.payNonce}}
						</div>
					</div> -->
				</div>
				<div class="all_tips_bottom_card">
					<button class="all_button22 text16 bmain_active" style="width: 100%;" @click="jump()">关闭</button>
					<!-- <button v-if="applyStatus==='2'" class="all_button22 text16 bmain_active"
						style="width: 45%;margin-right: 10%;" @click="deleteItem()">删除</button>
					<button class="all_button22 text16 bmain_active" :style="{width: applyStatus==='0'?'100%':'45%'}"
						@click="jump()">关闭</button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Dialog
	} from 'vant';
	import {
		closeCurrentPage
	} from '../../../utils/nativeOtherOperate.js'
	export default {
		name: 'authenterprisestatus',
		data() {
			return {
				//申请id
				//applyId: '',
				//企业id
				corpId: '',
				//企业名称
				corpName: '',
				//企业认证状态文本
				corpStatusText: '',
				//企业认证状态
				applyStatus: '1',
				//重新认证
				reAuth: '',
				//返回企业列表是否刷新
				backRefresh:'',
				//成功
				success: require('@/assets/images/selected.svg'),
				//认证中
				review: require('@/assets/images/review.svg'),
				//失败
				fail: require('@/assets/images/fail.svg'),
				//认证失败原因
				failMessage: '',
				//认证方式
				authStyle: '',
				//对公账户信息
				corporateAccountInfo: {
					companyName: '北京国富安电子商务安全认证有限公司',
					bankDeposit: '工商银行北京经济技术开发区宏达北路支行',
					bankAccount: '0200059009024509383',
					payMoney: '0.01元',
					//payNonce: 'esign',
					corpName: '',
					creditCode: '',
					certifyWay: 1
				},
			}
		},
		methods: {
			//获取对公账户信息
			getCorporateAccountInfo() {
				this.$post('/certify/api/getCorporateAccountInfo',
						JSON.stringify({
							applyId: this.applyId,
							certifyWay: 1
						}))
					.then((res) => {
						if (res.success && res.data) {
							this.corporateAccountInfo = res.data
						}
					})
			},
			//删除该条企业认证
			deleteItem() {
				var that = this
				Dialog.confirm({
						title: '提示',
						message: '确定删除该条企业认证？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						that.$store.dispatch(that.$LoadShow, true)
						that.$post('/certify/api/removeApply/' + that.applyId).then((res) => {
							that.$store.dispatch(that.$LoadShow, false)
							if (res.success) {
								this.$store.commit('changeEnterpriseDelete', true)
								that.$Toast("删除成功！")
								that.$router.go(-1)
							} else {
								that.$Toast(res.message || "删除失败！")
							}
						});
					})
					.catch(() => {
						// on cancel
					});
			},
			//重新认证
			// reAuth === 2
			toResetAuth() {
				this.$router.push({
					path: '/authenterpriseinfo',
					query: {
						corpId: this.corpId,
						reAuth: 2
					}
				})
			},
			// 执行法人人脸验证 返回结果后进行跳转下一页
			// 重新认证时需要多返回一页
			// this.reAuth 1 企业列表进入重新认证 2 企业列表进入状态，状态进入重新认证 3 企业列表进入法人认证
			jump() {
				if(this.$store.state.sourceFlag){
					closeCurrentPage()
					return
				}
				if(this.backRefresh){
					this.$store.commit('changeEnterpriseRefresh', true)
				}
				switch (this.applyStatus) {
					case '1':
						if (this.reAuth === '1') {
							this.$router.go(-3)
						} else if (this.reAuth === '2') {
							//缓存是否刷新
							this.$router.go(-4)
						} else if (this.reAuth === '3') {
							this.$router.go(-2)
						} else {
							if(this.corpName){
								this.$router.go(-1)
							}else{
								this.$router.go(-3)
							}
						}
						break;
					case '2':
						if (this.reAuth === '1') {
							this.$router.go(-3)
						} else if (this.reAuth === '2') {
							this.$router.go(-4)
						} else if (this.reAuth === '3') {
							this.$router.go(-2)
						} else {
							if(this.corpName){
								this.$router.go(-1)
							}else{
								this.$router.go(-3)
							}
						}
						break;
					case '4':
						this.$router.go(-1)
						break;
				}
			},
			//获取失败原因
			getStatusInfo() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/m/api/getCorpDetail?corpId=' + this.corpId)
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							// this.failMessage = res.data.auditMemo
							// "failMessage": null,失败原因
							// "certifyWay": null, 认证方式(0法人人脸识别+对公打款认证  1法人授权书+对公打款认证
							// "certifyWayText": null  认证方式描述
						}
					})
			},
			//初始化
			init() {
				this.$store.commit('changeEnterpriseDelete', false)
				this.$store.commit('changeEnterpriseRefresh', false)
				this.backRefresh = this.$route.query.refresh
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
				this.applyStatus = this.$route.query.applyStatus
				this.reAuth = this.$route.query.reAuth
				this.failMessage = this.$route.query.auditMemo
				// if (this.corpId && this.applyStatus === '0') {
				// 	this.getCorporateAccountInfo()
				// }
				if (this.corpId && (this.applyStatus === '1' || this.applyStatus === '4')) {
					this.getStatusInfo()
				}
			}
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
</style>